// context/useNavigationBlockContext.tsx
import React, { createContext, useContext, useState } from "react";

interface NavigationBlockContextType {
  isShowPopUp: boolean;
  setIsShowPopUp: (value: boolean) => void;
  nextRoute: string | null;
  setNextRoute: (route: string | null) => void;
  confirmNavigation: () => void;
}

const NavigationBlockContext = createContext<NavigationBlockContextType | undefined>(undefined);

export const NavigationBlockProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isShowPopUp, setIsShowPopUp] = useState(false);
  const [nextRoute, setNextRoute] = useState<string | null>(null);
  const [onConfirmAction] = useState<() => void>(() => () => {});

  const confirmNavigation = () => {
    onConfirmAction();
    setIsShowPopUp(false);
    setNextRoute(null);
  };

  return (
    <NavigationBlockContext.Provider
      value={{
        isShowPopUp,
        setIsShowPopUp,
        nextRoute,
        setNextRoute,
        confirmNavigation,
      }}
    >
      {children}
    </NavigationBlockContext.Provider>
  );
};

export const useNavigationBlock = () => {
  const context = useContext(NavigationBlockContext);
  if (!context) throw new Error("useNavigationBlock must be used within NavigationBlockProvider");
  return context;
};
